import { render } from "./Join1.vue?vue&type=template&id=63d22470&scoped=true"
import script from "./Join1.vue?vue&type=script&lang=js"
export * from "./Join1.vue?vue&type=script&lang=js"

import "./Join1.vue?vue&type=style&index=0&id=63d22470&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d22470"]])

export default __exports__